// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"161":"26a371c6","719":"95b2015b","844":"87d238a9","862":"9e5e46bd"}[chunkId] + ".js";
};